import React, {useEffect, useState} from "react";
import Dialog from "../../base/dialog";
import {DialogContent, DialogTitle, Divider} from "@mui/material";
import {Row} from "reactstrap";
import LoadingLottieAnimation from "../../app-specific/lottie-animations/loading";

const configInitState = {title: null, text: null, props: {}};

const ExportingDialog = () => {
    const [open, setOpen] = useState(false)
    const [config, setConfig] = useState(configInitState)

    /**
     * As soon as the component mounts:
     * - sets the global callback for opening this modal
     * Removes the set callback as soon as the component un-mounts.
     */
    useEffect(() => {
        window.partner = {
            ...(window.partner ?? {}),
            openExportingDialog: onOpen,
            closeExportingDialog: onClose,
        }
        return () => {
            delete window?.partner?.openExportingDialog;
            delete window?.partner?.closeExportingDialog;
        }
    }, [])


    /**
     * Opens the dialog and sets the configuration passed into it
     * @param {React.ReactNode} title the title of the dialog
     * @param {React.ReactNode} text the text of the dialog
     * @param {any} props the properties used in the modal
     */
    const onOpen = (title = null, text = null, props = {}) => {
        setConfig({title, text, props: props ?? {}})
        setOpen(true)
    }

    /**
     * Closes the modal and invokes the onClose callback set in the configurations.
     * @param {boolean | null} success
     */
    const onClose = (success = null) => {
        setOpen(false)
        if (success === null)
            return;
        setConfig(configInitState)
    }

    return (
        <>
            <Dialog
                maxWidth={'sm'}
                disableBackdropClick
                disableEscapeKeyDown
                loading
                {...(config.props ?? {})}
                open={open}
                setOpen={() => onClose(null)}>
                <DialogTitle className={'pb-0 px-0'}>
                    <Row xs={12} className='no-gutters justify-content-center w-100'>
                        <p className={`text-lg text-color-1 my-2 font-weight-semi-bold text-center`}>
                            {config?.title ?? 'Exporting Entries'}
                        </p>
                    </Row>
                    <Divider className='divider'/>
                </DialogTitle>
                <DialogContent>
                    {
                        config.text
                        ?? <div className={'p-3'}>
                            <p className={'text-sm text-color-2'}>
                                Please be patient while we prepare your records for exporting purposes.
                            </p>
                        </div>
                    }
                    <div className='my-2 w-100'/>
                    <LoadingLottieAnimation width={'80%'}/>
                    <div className='my-2 w-100'/>
                </DialogContent>
            </Dialog>
        </>
    )
}

export default ExportingDialog;
